import { FormItemsGroup, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { CompanyCity } from './elements/CompanyCity'
import { CompanyStreetAddress1 } from './elements/CompanyStreetAddress1'
import { CompanyStreetAddress2 } from './elements/CompanyStreetAddress2'
import { CompanyZipCode } from './elements/CompanyZipCode'

export const CompanyAddressSection = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <FormItemsGroup rowSpacing={Spacing.S16}>
      <Text variant="h3">
        {t('external_invoices.missing_company_compliance_details.modal.form.company_address_section.header')}
      </Text>
      <CompanyStreetAddress1 />
      <CompanyStreetAddress2 />
      <FormItemsGroup itemsInRow={10}>
        <CompanyZipCode />
        <CompanyCity />
      </FormItemsGroup>
    </FormItemsGroup>
  )
}
